import React from 'react';

export type InterestTranslationDraft = {
  translationKey: string;
  nameEn: string;
  nameDe: string;
  nameCs: string;
};

export function InterestTranslationFields({ value, onChange }: {
  value: InterestTranslationDraft;
  onChange: (field: keyof InterestTranslationDraft, value: string) => void;
}) {
  return (
    <fieldset className="admin-interest-translations">
      <legend>Translations</legend>
      <label className="admin-form-label">Translation key<input className="form-control mt-1 w-full" placeholder="Translation Key" value={value.translationKey} onChange={(event) => onChange('translationKey', event.target.value)} /></label>
      <label className="admin-form-label">English<input className="form-control mt-1 w-full" placeholder="English" value={value.nameEn} onChange={(event) => onChange('nameEn', event.target.value)} /></label>
      <label className="admin-form-label">German<input className="form-control mt-1 w-full" placeholder="German" value={value.nameDe} onChange={(event) => onChange('nameDe', event.target.value)} /></label>
      <label className="admin-form-label">Czech<input className="form-control mt-1 w-full" placeholder="Czech" value={value.nameCs} onChange={(event) => onChange('nameCs', event.target.value)} /></label>
    </fieldset>
  );
}
